import { render, staticRenderFns } from "./BisInbox.vue?vue&type=template&id=962fc31e&scoped=true"
import script from "./BisInbox.vue?vue&type=script&lang=js"
export * from "./BisInbox.vue?vue&type=script&lang=js"
import style0 from "./BisInbox.vue?vue&type=style&index=0&id=962fc31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962fc31e",
  null
  
)

export default component.exports